import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { hasIn } from 'lodash';
import { take } from 'rxjs/operators';

import { AdminAccount, selectAdminAccountState } from 'src/app/core';

interface BrandRolesAccess {
  brandUuid: string;
  roleUuids: string[];
}
@Directive({
  selector: '[appBrandRolesAccessCtrl]',
})
export class BrandRolesAccessCtrlDirective {
  brandRolesAccess: BrandRolesAccess[];
  @Input() set appBrandRolesAccessCtrl(brandRolesAccess: BrandRolesAccess[]) {
    this.brandRolesAccess = brandRolesAccess;
  }

  constructor(
    private store: Store,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.getAdminAccountState();
  }

  private getAdminAccountState() {
    this.store
      .pipe(select(selectAdminAccountState), take(1))
      .subscribe((adminAccount: AdminAccount) => {
        // if user has a brand
        if (hasIn(adminAccount, 'brandUuid')) {
          const brandUuid: string = adminAccount.brandUuid;

          // get component's brandRole
          const brandRolesAccess: BrandRolesAccess = this.brandRolesAccess.find(
            (br) => {
              return br.brandUuid === brandUuid;
            }
          );

          // check if user brand is amongst list of brands
          if (typeof brandRolesAccess !== 'undefined') {
            // check if user's role is in the brand role's access list
            if (
              brandRolesAccess.roleUuids.find((roleUuids) =>
                adminAccount.roleUuids.includes(roleUuids)
              )
            ) {
              this._hideComponent();
            } else {
              this._showComponent();
            }
          } else {
            // show component and let permissions handle hide/show
            this._showComponent();
          }
        } else {
          // user is most likely an admin
          this._showComponent();
        }
      });
  }

  private _showComponent() {
    this.viewContainer.createEmbeddedView(this.templateRef);
  }

  private _hideComponent() {
    this.viewContainer.clear();
  }
}
